import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { selectTabsPriority } from 'reducers/selectors/organiseTabs';
import { selectHasSetBudget, selectIsGBUser } from 'reducers/selectors';
import { Amplitude } from 'utils';
import { useMainStackNavigation } from 'utils/types/navigationV6';
export const useBudgetingNavigate = () => {
    const navigation = useMainStackNavigation();
    const { navigateToTab } = useTabNavigation();
    const { priority } = useAppSelector(selectTabsPriority);
    const isGBUser = useAppSelector(selectIsGBUser);
    const hasSetBudget = useAppSelector(selectHasSetBudget);
    const { isUnlockedForSpace } = useShouldShowUpgrade({
        benefitId: 'budgeting',
    });
    const onSuccess = useCallback(() => {
        const isBudgetingTabVisible = priority.includes('budgeting');
        if (isGBUser || !isBudgetingTabVisible) {
            navigation.navigateDeprecated('Budgeting');
        }
        else {
            navigateToTab('BudgetingTab');
        }
    }, [isGBUser, priority]);
    const onNavigate = useCallback(() => {
        const isBudgetingTabVisible = priority.includes('budgeting');
        if (isUnlockedForSpace && hasSetBudget) {
            onSuccess();
        }
        else {
            if (isGBUser || !isBudgetingTabVisible) {
                navigation.navigateDeprecated('SetUpBudget', {});
            }
            else {
                navigateToTab('BudgetingTab');
            }
            Amplitude.logEvent('Feed.openBudgetingSetup');
        }
    }, [hasSetBudget, isGBUser, isUnlockedForSpace, onSuccess, priority]);
    return {
        onNavigate,
        onSuccess,
    };
};
